// extracted by mini-css-extract-plugin
export default {"photo":"social-location-section-LocationSectionPhotoWrap__photo--34p7l","photo_wrap":"social-location-section-LocationSectionPhotoWrap__photo_wrap--3c7y0"};